module.exports = __webpack_public_path__ + "static/media/Calcumpare.0f159b77.jpg";